import { ErrorBoundary } from 'components/ErrorBoundary';
import LoadingIndicator from 'components/LoadingIndicator';
import React, { Suspense } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import GateLayout from '../containers/GateLayout';

interface GateLayoutProps extends RouteProps {
  component: any;
}

export default function ({ component: Component, ...rest }: GateLayoutProps) {
  const loggedIn = !!localStorage.getItem('token');

  return (
    <Route
      {...rest}
      render={(matchProps) =>
        loggedIn ? (
          <GateLayout size="large">
            <Suspense fallback={<LoadingIndicator />}>
              <ErrorBoundary>
                <Component {...matchProps} />
              </ErrorBoundary>
            </Suspense>
          </GateLayout>
        ) : (
          <Redirect
            push
            to={{
              pathname: '/signin',
              search: `?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`,
              state: { referrer: matchProps.location },
            }}
          />
        )
      }
    />
  );
}
